var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3335 1.99935H11.6668V0.666016H10.3335V1.99935H3.66683V0.666016H2.3335V1.99935H1.66683C0.933496 1.99935 0.333496 2.59935 0.333496 3.33268V13.9993C0.333496 14.7327 0.933496 15.3327 1.66683 15.3327H12.3335C13.0668 15.3327 13.6668 14.7327 13.6668 13.9993V3.33268C13.6668 2.59935 13.0668 1.99935 12.3335 1.99935ZM12.3335 13.9993H1.66683V6.66602H12.3335V13.9993ZM12.3335 5.33268H1.66683V3.33268H12.3335V5.33268Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.47d5bbd5dad801ee8308e3ca6f0a5c79.svg";
export { ForwardRef as ReactComponent };